import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './en.json';
import tw from './zh-TW.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en',
  messages: {
    'zh-TW': tw,
    en: en
  },
  fallbackLocale: 'en',
  silentTranslationWarn: true
});

// 设置多语言

export default i18n;
